import type vtkCamera from '@kitware/vtk.js/Rendering/Core/Camera';

/** Change magnification around the current focal point, preserving orientation. */
export function zoomCamera(camera: vtkCamera, factor: number) {
  if (!Number.isFinite(factor) || factor <= 0) return;
  if (camera.getParallelProjection()) {
    camera.setParallelScale(Math.max(0.0001, Math.min(1e6, camera.getParallelScale() / factor)));
  } else {
    camera.computeDistance();
    const distance = camera.getDistance();
    const nextDistance = Math.max(0.001, Math.min(1e6, distance / factor));
    camera.dolly(distance / nextDistance);
  }
}
